import React from 'react'
import { useDispatch } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import {
  Button,
  Card,
  ClientContacts,
  FormText,
  Icon,
  SelectClient,
} from 'src/components'
import { faEdit, faEnvelope, faSave } from '@fortawesome/free-solid-svg-icons'
import { setModalCreateClient, setModalEditClient } from 'src/actions/utilities.actions'
import {
  actionTypes as clientActions,
  onCreateClientStep,
} from 'src/actions/clients.actions'
import { getOrderBalanceByCustomers } from 'src/actions/orders.actions'
import IdentificationField from 'src/components/IdentificationField/IdentificationField'
import { identificationTypesEnum } from 'src/enums/identificationTypes'
import { formatNumberWithCommas } from 'src/utils/formatters'
import { usePermissionClientSell } from 'src/content/Orders/OrderCreate/usePermissionClientSell'
import { haveAnyValue } from 'src/utils/utilitiesV2'
import { showAlert } from 'src/actions/alert.actions'
import { handlerWarning } from 'src/selectors/error.selector'

const OrderClientSection = ({
  order,
  setOrder,
  identifications,
  setIdentifications,
  clientNIT,
  setClientNIT,
  clientCUI,
  setClientCUI,
  loadingClients,
  isVisit,
  canViewAll,
  seeBalances,
  isGT,
  identificationTypes,
  handleChangeClient,
  handleCreatedClient,
  changeText,
  setClientBalanceModal,
}) => {
  const dispatch = useDispatch()

  const { canCreate, canUpdate } = usePermissionClientSell()

  const isUpdate = haveAnyValue(order.client?.id)
  const canChange = order.client?.id > 0

  const handleIdentificationSearch = (info, ids) => {
    if (info.clientInfo) {
      handleChangeClient(info, ids)
    } else {
      if (!canCreate) {
        showNoCreateClient(info.clientName, info.NIT || info.cui)
        return
      }
      dispatch(setModalCreateClient({ show: true, onCreateOption: handleCreatedClient }))
      dispatch(
        onCreateClientStep({
          companyName: info.clientName,
          businessName: info.clientName,
          identifications: ids,
          nit: info.NIT || 'cf',
          cui: info.cui,
        }),
      )
    }
  }

  const showNoCreateClient = (clientName, identification) => {
    const title = 'Cliente no registrado'
    const message = `${clientName} (${identification}) no está registrado en la empresa y no tienes permisos para crear clientes. Contacta a un administrador.`

    setClientNIT('CF')
    setClientCUI(null)

    dispatch(
      showAlert({
        ...handlerWarning(title, message),
      }),
    )
  }

  return (
    <Card>
      <Row>
        <Col xs={12} md={3}>
          <SelectClient
            actionType={clientActions.GET_CLIENT_POLYGON}
            className="mt-3"
            onChange={(client, ids) => handleChangeClient(client, ids)}
            value={order.client}
            identifications={identifications}
            onCreateOption={handleCreatedClient}
            disabled={loadingClients || isVisit}
            allClients={!isVisit && canViewAll}
            init
          />
          {order.client?.balance && order.client?.balance > 0 && seeBalances ? (
            <div
              className="ft-sub left mt-2 ml-2"
              style={{ cursor: 'pointer', fontWeight: 500, textDecoration: 'underline' }}
              onClick={() => {
                setClientBalanceModal({ show: true })
                dispatch(getOrderBalanceByCustomers(order.client?.value))
              }}>
              Saldo: {formatNumberWithCommas(order.client?.balance)}, Ver ordenes
              pendientes de pago(s)
            </div>
          ) : (
            <div />
          )}
          {order.client?.vouchers > 0 ? (
            <div className="ft-sub left mt-2 ml-2" style={{ fontWeight: 500 }}>
              Saldo a favor: {formatNumberWithCommas(order.client.vouchers)}
            </div>
          ) : (
            <div />
          )}
        </Col>
        {isGT ? (
          <>
            <Col xs={12} md={3}>
              <IdentificationField
                name={'nit'}
                identificationTypeId={identificationTypesEnum.NIT_GT}
                value={clientNIT}
                onChange={setClientNIT}
                onSearch={handleIdentificationSearch}
                disabled={order?.status === 3}
                required
              />
            </Col>
            <Col xs={12} md={3}>
              <IdentificationField
                name={'dpi'}
                identificationTypeId={identificationTypesEnum.CUI}
                value={clientCUI}
                onChange={setClientCUI}
                onSearch={handleIdentificationSearch}
                disabled={order?.status === 3}
              />
            </Col>
          </>
        ) : (
          identificationTypes
            .filter(identificationType => identificationType.countryId !== null)
            .map(identificationType => (
              <Col key={identificationType.id} xs={12} md={3}>
                <IdentificationField
                  identificationTypeId={identificationType.id}
                  value={identifications[identificationType.id]?.value}
                  onChange={value => {
                    identifications[identificationType.id] = {
                      identificationTypeId: identificationType.id,
                      value,
                    }
                    setIdentifications(identifications)
                    setOrder({ ...order, save: true })
                  }}
                  disabled={order?.status === 3}
                />
              </Col>
            ))
        )}
        {identificationTypes
          .filter(identificationType => identificationType.countryId === null)
          .map(identificationType => (
            <Col key={identificationType.id} xs={12} md={3}>
              <IdentificationField
                identificationTypeId={identificationType.id}
                value={identifications[identificationType.id]?.value}
                onChange={value => {
                  identifications[identificationType.id] = {
                    identificationTypeId: identificationType.id,
                    value,
                  }
                  setIdentifications(identifications)
                  setOrder({ ...order, save: true })
                }}
                disabled={order?.status === 3}
              />
            </Col>
          ))}
        <Col xs={12} md={3}>
          <FormText
            label={'Correo'}
            type={'email'}
            name={'email'}
            value={order.client ? order.client.email || '' : ''}
            prepend={<Icon icon={faEnvelope} />}
            disabled={order?.status === 3}
            onChange={changeText}
          />
        </Col>
        <Col xs={12} md={3}>
          <ClientContacts
            show
            id={order?.client?.id}
            optionMode
            value={order?.contact}
            onChange={value => {
              let newContact = null
              if (value) newContact = { ...value, label: value.name }
              setOrder({ ...order, contact: newContact })
            }}
            disabledSelect={order?.status === 3}
          />
        </Col>
        {(isUpdate ? canUpdate : canCreate) && canChange && (
          <Col xs={12} md={3} style={{ marginTop: '45px' }}>
            <Button
              className={'align-bottom'}
              onClick={() => {
                if (isUpdate) {
                  dispatch(
                    setModalEditClient({
                      show: true,
                      id: order?.client?.id,
                      onSave: (client, ids) => {
                        handleChangeClient(
                          { ...client, value: client.id, label: client.companyName },
                          ids,
                        )
                      },
                    }),
                  )
                } else {
                  dispatch(
                    setModalCreateClient({
                      show: true,
                      onCreateOption: handleCreatedClient,
                    }),
                  )
                  dispatch(
                    onCreateClientStep({
                      companyName: order.client.name,
                      businessName: order.client.name,
                      identifications,
                      email: order.client.email,
                      address: order.client.address,
                      nit: order.client.nit,
                      cui: order.client.cui,
                    }),
                  )
                }
              }}
              icon={isUpdate ? faEdit : faSave}>
              {isUpdate ? 'Editar' : 'Crear'}
            </Button>
          </Col>
        )}
      </Row>
    </Card>
  )
}

export default OrderClientSection
